import type { ReactNode } from 'react';
import { LogoMark } from '../../ui/icons';
import { ThemeToggle } from '../../ui/TopBar';

export function AuthLayout({ title, subtitle, children, footer }: {
  title: string;
  subtitle: string;
  children: ReactNode;
  footer: ReactNode;
}) {
  return (
    <div className="flex min-h-dvh flex-col pt-[var(--safe-top)] pb-[var(--safe-bottom)]">
      <div className="flex justify-end px-2 pt-2">
        <ThemeToggle />
      </div>
      <main className="mx-auto flex w-full max-w-sm flex-1 flex-col justify-center px-5 pb-10">
        <div className="mb-8 flex flex-col items-center text-center">
          <LogoMark size={56} />
          <p className="mt-4 text-sm font-semibold tracking-wide text-accent uppercase">Cady</p>
          <h1 className="mt-1 text-[1.75rem] leading-tight font-bold tracking-tight text-ink">{title}</h1>
          <p className="mt-2 text-muted">{subtitle}</p>
        </div>
        <div className="rounded-3xl border border-line bg-surface p-5 shadow-sm">{children}</div>
        <p className="mt-6 text-center text-[0.95rem] text-muted">{footer}</p>
      </main>
    </div>
  );
}
